var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      class: _vm.classes,
      attrs: { role: "treeitem", draggable: _vm.draggable },
      on: {
        dragstart: function($event) {
          $event.stopPropagation()
          return _vm.onItemDragStart($event, _vm._self, _vm._self.model)
        },
        dragend: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.onItemDragEnd($event, _vm._self, _vm._self.model)
        },
        dragover: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          _vm.isDragEnter = true
        },
        dragenter: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          _vm.isDragEnter = true
        },
        dragleave: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          _vm.isDragEnter = false
        },
        drop: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.handleItemDrop($event, _vm._self, _vm._self.model)
        }
      }
    },
    [
      _vm.isWholeRow
        ? _c(
            "div",
            { class: _vm.wholeRowClasses, attrs: { role: "presentation" } },
            [_vm._v(" ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("i", {
        staticClass: "tree-icon tree-ocl",
        attrs: { role: "presentation" },
        on: { click: _vm.handleItemToggle }
      }),
      _vm._v(" "),
      _c(
        "div",
        _vm._g({ class: _vm.anchorClasses }, _vm.events),
        [
          _vm.model.showCheckbox && !_vm.model.loading
            ? _c("i", {
                staticClass: "tree-icon tree-checkbox",
                attrs: { role: "presentation" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._t(
            "default",
            function() {
              return [
                !_vm.model.loading
                  ? _c("i", {
                      class: _vm.themeIconClasses,
                      attrs: { role: "presentation" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    textContent: _vm._s(_vm.model[_vm.textFieldName])
                  }
                })
              ]
            },
            { vm: this, model: _vm.model }
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.isAfterMiddleArea ? "tree-after-middle-area" : "",
          staticStyle: {
            width: "100%",
            height: "5px",
            position: "absolute",
            "z-index": "1"
          },
          attrs: { name: "middleArea" },
          on: {
            dragend: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.onItemDragEnd($event, _vm._self, _vm._self.model)
            },
            dragover: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              _vm.isAfterMiddleArea = true
            },
            dragenter: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              _vm.isAfterMiddleArea = true
            },
            dragleave: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              _vm.isAfterMiddleArea = false
            },
            drop: function($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.handleItemDrop(
                $event,
                _vm._self,
                _vm._self.model,
                _vm.parentItem,
                _vm.parent
              )
            }
          }
        },
        [
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isAfterMiddleArea,
                expression: "isAfterMiddleArea"
              }
            ],
            staticClass: "arrow-top"
          }),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isAfterMiddleArea,
                expression: "isAfterMiddleArea"
              }
            ],
            staticClass: "arrow-bottom"
          })
        ]
      ),
      _vm._v(" "),
      _vm.isFolder
        ? _c(
            "ul",
            {
              ref: "group",
              staticClass: "tree-children",
              style: _vm.groupStyle,
              attrs: { role: "group" }
            },
            _vm._l(_vm.model[_vm.childrenFieldName], function(child, index) {
              return _c("tree-item", {
                key: index,
                attrs: {
                  "before-item-click": _vm.beforeItemClick,
                  data: child,
                  parent: _vm._self.model,
                  "text-field-name": _vm.textFieldName,
                  "value-field-name": _vm.valueFieldName,
                  "children-field-name": _vm.childrenFieldName,
                  "item-events": _vm.itemEvents,
                  "whole-row": _vm.wholeRow,
                  "show-checkbox": _vm.model.showCheckbox,
                  "allow-transition": _vm.allowTransition,
                  height: _vm.height,
                  "parent-item": _vm.model[_vm.childrenFieldName],
                  draggable: _vm.draggable,
                  "drag-over-background-color": _vm.dragOverBackgroundColor,
                  "on-item-click": _vm.onItemClick,
                  "on-item-check": _vm.onItemCheck,
                  "on-item-toggle": _vm.onItemToggle,
                  "on-item-drag-start": _vm.onItemDragStart,
                  "on-item-drag-end": _vm.onItemDragEnd,
                  "on-item-drop": _vm.onItemDrop,
                  klass:
                    index === _vm.model[_vm.childrenFieldName].length - 1
                      ? "tree-last"
                      : ""
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(_) {
                        return [
                          _vm._t(
                            "default",
                            function() {
                              return [
                                !_vm.model.loading
                                  ? _c("i", {
                                      class: _.vm.themeIconClasses,
                                      attrs: { role: "presentation" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _.model[_vm.textFieldName]
                                    )
                                  }
                                })
                              ]
                            },
                            { vm: _.vm, model: _.model }
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            }),
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76fc86d7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76fc86d7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/control/treeEcho/TreeItem.vue
// module id = null
// module chunks = 